import { useEffect, useState } from "react";
import { Modal, Button } from "antd";

const IdleTimerPopUp = ({ isOpen, onStillHere, onLogout, warningTimeout }) => {
  const [countdown, setCountdown] = useState(Math.floor(warningTimeout / 1000));

  useEffect(() => {
    if (!isOpen) {
      setCountdown(Math.floor(warningTimeout / 1000));
      return;
    }

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, warningTimeout]);

  return (
    <Modal
      title="Are you still there?"
      open={isOpen}
      closable={false}
      maskClosable={false}
      footer={[
        <Button key="logout" danger onClick={onLogout}>
          Logout
        </Button>,
        <Button key="still-here" type="primary" onClick={onStillHere}>
          I'm still here
        </Button>,
      ]}
    >
      <p>
        Your session will expire in <strong>{countdown} seconds</strong> due to inactivity.
      </p>
    </Modal>
  );
};

export default IdleTimerPopUp;